export const FilledGreenTick = ({
  width = "80",
  height = "80",
}: {
  width?: string;
  height?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.40747"
      y="2.22223"
      width="15.5556"
      height="15.5556"
      rx="7.77778"
      fill="currentColor"
    />
    <path
      d="M7.75476 10.4589L9.31032 11.8966L12.9399 8.54169"
      stroke="white"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
